import { CurrentTripContext } from '../context/CurrentTripContext'
import { useContext } from 'react'

export const useCurrentTripContext = () => {
    const context = useContext(CurrentTripContext)  //consumes the context

    if (!context) {
        throw Error('useCurrentTripContext must be used inside a CurrentTripContextProvider')
    }

    return context
}